import { LOCATION_CHANGE } from '../../../../../shared/frontend/libs/router/redux-store';
import {
  SET_ARTICLE_CONTENT,
  SET_ARTICLE_LOADING,
  SET_ARTICLE_WEEKLY_ROUTES,
  SET_ARTICLE_WEEKLY_ROUTES_LOADING,
  SET_ARTICLES_PLAY_LIKE_THE_PROS,
  SET_ARTICLES_PLAY_LIKE_THE_PROS_LOADING
} from '../actions/newsArticleActionCreator';
import { TAction } from '../actions/types/action';
import { TCharacterDetailsClientState, TNewsArticleState } from '../libs/store';

const DEFAULT_STATE: TNewsArticleState = {
  article: {
    isLoading: false,
    isLoaded: false,
    article: null
  },
  articlesWeeklyRoute: {
    isLoading: false,
    isLoaded: false,
    list: []
  },
  articlesPlayLikeThePros: {
    isLoading: false,
    isLoaded: false,
    list: []
  }
};

export default function newsArticle(
  state: Partial<TCharacterDetailsClientState> = DEFAULT_STATE,
  action: TAction<any>
): Partial<TCharacterDetailsClientState> {
  switch (action.type) {
    case SET_ARTICLE_LOADING: {
      const newState: any = {
        ...state,
        article: {
          ...state.article,
          isLoading: action.payload.loading,
          isLoaded: !action.payload.loading
        }
      };
      return newState;
    }
    case SET_ARTICLE_CONTENT: {
      return {
        ...state,
        article: {
          ...action.payload,
          isLoaded: true
        }
      };
    }
    case SET_ARTICLE_WEEKLY_ROUTES_LOADING: {
      return {
        ...state,
        articlesWeeklyRoute: {
          ...state.articlesWeeklyRoute,
          isLoading: action.payload.loading,
          isLoaded: !action.payload.loading
        }
      };
    }
    case SET_ARTICLE_WEEKLY_ROUTES: {
      return {
        ...state,
        articlesWeeklyRoute: {
          ...state.articlesWeeklyRoute,
          list:
            action.payload.articles?.map((articleWeeklyRoute: any) => ({
              ...articleWeeklyRoute,
              title: articleWeeklyRoute.title.replace(/The Weekly Route: /i, '')
            })) || [],
          isLoaded: true
        }
      };
    }
    case SET_ARTICLES_PLAY_LIKE_THE_PROS_LOADING: {
      return {
        ...state,
        articlesPlayLikeThePros: {
          ...state.articlesPlayLikeThePros,
          isLoading: action.payload.loading,
          isLoaded: !action.payload.loading
        }
      };
    }
    case SET_ARTICLES_PLAY_LIKE_THE_PROS: {
      return {
        ...state,
        articlesPlayLikeThePros: {
          ...state.articlesPlayLikeThePros,
          list: action.payload.articles,
          isLoaded: true
        }
      };
    }
    case LOCATION_CHANGE: {
      rioDebouncedRefreshWowheadTooltips();
      return state;
    }
    default: {
      return state;
    }
  }
}
